var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTestCodingBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3334 9.3335H11.6667C10.378 9.3335 9.33337 10.3782 9.33337 11.6668V47.8335C9.33337 49.1222 10.378 50.1668 11.6667 50.1668H44.3334C45.622 50.1668 46.6667 49.1222 46.6667 47.8335V11.6668C46.6667 10.3782 45.622 9.3335 44.3334 9.3335Z",
    fill: "#3987F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.8335H21C20.3557 5.8335 19.8334 6.35583 19.8334 7.00016V11.6668C19.8334 12.3112 20.3557 12.8335 21 12.8335H35C35.6444 12.8335 36.1667 12.3112 36.1667 11.6668V7.00016C36.1667 6.35583 35.6444 5.8335 35 5.8335Z",
    fill: "#2C6CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4877 28.903L35.5691 24.9844C34.9427 24.3579 33.927 24.3579 33.3005 24.9844C32.674 25.6109 32.674 26.6266 33.3005 27.253L37.219 31.1716C37.8455 31.7981 38.8612 31.7981 39.4877 31.1716C40.1141 30.5451 40.1141 29.5294 39.4877 28.903Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2202 28.911L33.3017 32.8296C32.6752 33.456 32.6752 34.4717 33.3017 35.0982C33.9281 35.7247 34.9438 35.7247 35.5703 35.0982L39.4889 31.1796C40.1153 30.5532 40.1153 29.5375 39.4889 28.911C38.8624 28.2845 37.8467 28.2845 37.2202 28.911Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7794 31.1725L22.698 27.2539C23.3244 26.6275 23.3244 25.6118 22.698 24.9853C22.0715 24.3588 21.0558 24.3588 20.4293 24.9853L16.5108 28.9039C15.8843 29.5303 15.8843 30.546 16.5108 31.1725C17.1372 31.799 18.1529 31.799 18.7794 31.1725Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.512 31.1796L20.4305 35.0981C21.057 35.7246 22.0727 35.7246 22.6991 35.0981C23.3256 34.4716 23.3256 33.4559 22.6991 32.8295L18.7806 28.9109C18.1541 28.2845 17.1384 28.2845 16.512 28.9109C15.8855 29.5374 15.8855 30.5531 16.512 31.1796Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9396 25.5185L25.0467 33.4667C24.7437 34.2992 25.1729 35.2198 26.0055 35.5228C26.838 35.8258 27.7585 35.3965 28.0616 34.564L30.9545 26.6158C31.2575 25.7833 30.8282 24.8627 29.9957 24.5597C29.1632 24.2567 28.2426 24.6859 27.9396 25.5185Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestCodingBlue);
export default __webpack_public_path__ + "static/media/icon_test_coding_blue.e0dc9927.svg";
export { ForwardRef as ReactComponent };